import { useCallback } from 'react';
import { API, endpoints } from 'src/api';

export function useMultiplayerAssets() {
  const onAssetCreate = useCallback(async (file: File, id: string): Promise<string | false> => {
    const data = new FormData();
    data.append('file', file);

    const response = await API.post(endpoints.creationFile.url, data, {
      headers: { ['Content-Type']: 'multipart/form-data' },
    });

    return response.data?.data?.message.url;
  }, []);

  const onAssetDelete = useCallback(async (id: string): Promise<boolean> => {
    // noop
    return true;
  }, []);

  return { onAssetCreate, onAssetDelete };
}
